import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

export default function StartPhoneVerificationDialog({
  openState,
  userContext,
  onClose,
  onConfirm,
}) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [refreshNotice, setRefreshNotice] = useState("");

  useEffect(() => {
    if (openState) {
      setSubmitting(false);
      setError("");
      setRefreshNotice("");
    }
  }, [openState, userContext?.userId]);

  if (!("row" in userContext)) {
    return <></>;
  }

  const phoneDisplay =
    typeof userContext.row.phoneNumber === "string"
      ? userContext.row.phoneNumber.trim()
      : "";

  const alreadyInvited =
    userContext.row?.phoneVerification?.status === "phone_verification_ready";
  const codeAlreadyActive =
    userContext.row?.phoneVerification?.status === "code_sent";

  const handleSubmit = async () => {
    setSubmitting(true);
    setError("");
    setRefreshNotice("");

    const result = await onConfirm({ userId: userContext.row.userId });

    if (result?.ok) {
      if (result?.refreshError) {
        setRefreshNotice(
          "Invitation email sent, but the user list failed to refresh. Please refresh before sending again."
        );
        setSubmitting(false);
        return;
      }

      onClose();
      return;
    }

    setError(result?.error || "Failed to send phone verification invitation");
    setSubmitting(false);
  };

  return (
    <Dialog
      open={openState}
      onClose={submitting ? undefined : onClose}
      aria-labelledby="start-phone-verification-dialog-title"
    >
      <DialogTitle id="start-phone-verification-dialog-title">
        Approve phone verification for {userContext.row.nickname}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          This sends an email to the player letting them know their details have passed
          initial review and they can now verify their phone number from their account
          settings. The player initiates the SMS themselves when ready. They must complete
          phone verification before you can mark them as verified.
        </DialogContentText>
        <Typography variant="body2" style={{ marginTop: 12 }}>
          <strong>Phone:</strong> {phoneDisplay || "—"}
        </Typography>
        {alreadyInvited ? (
          <Typography variant="body2" style={{ marginTop: 12, color: "#ed6c02" }}>
            An invitation has already been sent to this player. They can request the SMS
            from their account settings.
          </Typography>
        ) : null}
        {codeAlreadyActive ? (
          <Typography variant="body2" style={{ marginTop: 12, color: "#ed6c02" }}>
            A verification code is already active for this player. They have already
            requested the SMS and are in the process of verifying.
          </Typography>
        ) : null}
        {error ? (
          <Typography variant="body2" style={{ marginTop: 12, color: "#d32f2f" }}>
            {error}
          </Typography>
        ) : null}
        {refreshNotice ? (
          <Typography variant="body2" style={{ marginTop: 12, color: "#ed6c02" }}>
            {refreshNotice}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          disabled={
            submitting || Boolean(refreshNotice) || alreadyInvited || codeAlreadyActive
          }
        >
          {submitting ? "Sending…" : "Send Invitation Email"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
